import { useTranslation } from "react-i18next";
import {
    HeaderWrapper,
    HeaderRow,
    HeaderTitleLeft,
} from "../DashboardHeader/DashboardHeader.StyledComponents";
import { useAppContext } from "@/app/components/providers/AppContextProvider";


export const InvoicesTableHeader = () => {
  const { t } = useTranslation("invoicesDashboard");
  const { theme } = useAppContext();

  return (
    <div>
        <HeaderWrapper>
          <HeaderRow>
            <HeaderTitleLeft>
              {t("invoiceList.title")}
            </HeaderTitleLeft>
          </HeaderRow>
        </HeaderWrapper>
    </div>
  );
};
